import { Link } from 'react-router-dom';

export default function MissingAgentNotice() {
  return (
    <p style={{ color: 'var(--text-muted)', lineHeight: 1.5 }}>
      No travel agent is set up yet.{' '}
      <Link to="/admin/agents" style={{ color: 'var(--accent)', fontWeight: 700 }}>
        Add an agent
      </Link>{' '}
      to send quotes and use this workspace.
    </p>
  );
}
